import { useMemo } from 'react';
import { useQuery } from 'react-apollo';
import gql from 'graphql-tag';
import get from 'lodash.get';
import moment from 'moment';

interface QueryResponse {
  patient: {
    id: string;
    birthday: string;
  };
}

const query = gql`
  query patientBirthday {
    patient {
      id
      birthday
    }
  }
`;

const useUserAge = () => {
  const { data } = useQuery<QueryResponse>(query);
  const birthday = get(data, 'patient.birthday');

  const userAge = useMemo(() => moment().diff(birthday, 'years'), [birthday]);

  return userAge;
};

export default useUserAge;
